<template>
  <div id="app">
    <template v-if="isMobile">
      <complianceDialog></complianceDialog>
    </template>
    <template v-else>
      <mobileComplianceDialog></mobileComplianceDialog>
    </template>
    <router-view/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isMobile: !window.matchMedia('(max-width: 767px)').matches
    }
  },
  mounted () {
  },
  watch: {
    $route: {
      handler (newRoute) {
        const app = document.querySelector('#app')
        if (newRoute.name !== 'aboutUs' && !window.matchMedia('(max-width: 767px)').matches) {
          app.style.paddingTop = '70px'
          localStorage.setItem('isAbout', 'false')
        } else if (newRoute.name === 'aboutUs' && !window.matchMedia('(max-width: 767px)').matches) {
          app.style.paddingTop = ''
          localStorage.setItem('isAbout', 'true')
        } else if (window.matchMedia('(max-width: 767px)').matches) {
          app.style.paddingTop = '1.6rem'
          localStorage.setItem('isAbout', 'true')
        }
      },
      immediate: true,
      deep: true
    }
  }

}
</script>

<style lang="less">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // font-family: NotoSans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
